

export default {
  install(vue) {
    const notify = function(message, type = "success") {
      this.$notifications.notify({
        message: message,
        /*icon: 'nc-icon nc-app',*/
        horizontalAlign: 'right',
        verticalAlign: "top",
        type,
      })
    }
    const catchError = function(err) {
      if (err && err.response && err.response.data) {
        if (err.response.data.errors) {
          notify.apply(this, [err.response.data.errors[0], "danger"])
        } else if (err.response.data[0] && err.response.data[0].message) {
          notify.apply(this, [err.response.data[0].message, "danger"])
        } else if (err.response.statusText) {
          notify.apply(this, [err.response.statusText, "danger"])
        }
      }
    }

    vue.prototype.$catchError = function(err) {
      catchError.apply(this, [err])
    }

    vue.prototype.$success = function(message) {
      notify.apply(this, [message])
    }

    vue.prototype.$error = function(message) {
      notify.apply(this, [message, "danger"])
    }

    vue.prototype.$pushModal = function(...args) {
      this.$store.commit("pushModal", ...args)
    }

    vue.prototype.$logout = async function() {
      if (await this.$handlePromise(
        this.axios.get("/logout"), "Er is een fout opgetreden bij het uitloggen"
      )) {
        this.$store.commit("setUser", null)
        this.$router.push("/sign-in").catch(()=>{})
      }
    }

    vue.prototype.$confirmAction = function(callback, options) {
      this.$store.commit("pushModal", {
        toBind: {
          ...options,
          callback,
        },
        modal: "ConfirmAction",
      })
    }

    vue.prototype.$handlePromise = async function(callback, loadingScreen = true, errorMessage) {
      try {
        loadingScreen && this.$store.commit("loading", true)
        const res = callback.then ? await callback : await callback()
        loadingScreen && this.$store.commit("loading", false)
        return res
      } catch (err) {
        console.error(err)

        if (err && err.response && err.response.status === 401) {
          this.$logout()
        }

        if (errorMessage) {
          this.$error(errorMessage)
        } else {
          catchError.apply(this, [err])
        }

        loadingScreen && this.$store.commit("loading", false)
        return null
      }
    }

    vue.prototype.$checkAuthentication = function() {
      this.$handlePromise(
        this.axios.get("/api/websites"), false
      )
    }
  },
}
